<template lang="pug">
  div.chart-container(v-loading="loadChart")
    <canvas id="myChart"></canvas>
</template>

<script>
import ChartJS from 'chart.js'

export default {
  name: 'PollutionChart',
  data () {
    return {
      chart: null,
      monthLabel: this.$t('predictiveModels.month')
    }
  },
  props: {
    loadChart: {
      type: Boolean,
      default: false
    },
    chartData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    initLineChart () {
      const data = {
        labels: this.labelGraphMonth(),
        datasets: [
          {
            label: this.$t('predictiveModels.historical'),
            fill: false,
            backgroundColor: '#3982D0',
            borderColor: '#3982D0',
            pointRadius: 0,
            tension: 0,
            data: this.chartData.historicalData.fill(NaN, 7, 13)
            // data: Array.from({length: 13}, () => Math.floor(Math.random() * 500))
          }, {
            label: this.$t('predictiveModels.prediction'),
            fill: true,
            backgroundColor: 'transparent',
            borderColor: '#3982D0',
            borderDash: [2, 4],
            pointRadius: 0,
            tension: 0,
            data: this.chartData.predictiveData.fill(NaN, 7, 13)
          }, {
            label: this.$t('predictiveModels.alertLevel'),
            fill: false,
            backgroundColor: '#FFA800',
            borderColor: '#FFA800',
            borderWidth: 2,
            pointRadius: 0,
            tension: 0,
            data: this.chartData.alertLevelData
          }, {
            label: 'Future',
            fill: false,
            backgroundColor: 'transparent',
            borderColor: '#3982D0',
            borderDash: [2, 4],
            pointRadius: 0,
            tension: 0,
            data: this.chartData.futureData.fill(NaN, 0, 6)
          }
        ]
      }
      let ctx = document.getElementById('myChart').getContext('2d')
      this.chart = new ChartJS(ctx, {
        type: 'line',
        lineAtIndex: [6],
        data: data,
        plugins: [{
          // AÑade margen entre el legend y el gráfico
          beforeInit: function (chart, options) {
            chart.legend.afterFit = function () {
              this.height = this.height + 25
            }
          }
        }],
        options: {
          responsive: true,
          legend: {
            align: 'start',
            labels: {
              boxWidth: 14,
              padding: 18,
              filter: function (item, chart) {
                // Elimina el legend que coincida con lo indicado
                return !item.text.includes('Future')
              }
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 20,
                fontSize: 9,
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0
              }
            }],
            yAxes: [{
              gridLines: {
                drawTicks: false,
                drawBorder: false
              },
              ticks: {
                padding: 9,
                fontSize: 9,
                max: 500,
                min: 0,
                stepSize: 100
              },
              scaleLabel: {
                display: true,
                labelString: this.$t('predictiveModels.levelsCO2'),
                fontSize: 11
              }
            }]
          }
        }
      })
      this.printVerticalLine()
    },
    labelGraphMonth () {
      let months = {
        English: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        Spanish: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
      }
      let aux = []
      let elem = new Date()
      elem.setHours(0)
      elem.setMinutes(0)
      let newDay = new Date()
      newDay.setMonth((elem.getMonth() - 7))
      for (var i = 0; i < 13; i++) {
        newDay.setMonth((newDay.getMonth() + 1))
        aux.push('' + months[this.$i18n.locale][newDay.getMonth()])
      }
      // despues hacer un for sumando meses y listo
      return aux
    },
    // Pinta la línea vertical
    printVerticalLine () {
      const verticalLinePlugin = {
        getLinePosition: function (chart, pointIndex) {
          const meta = chart.getDatasetMeta(0) // first dataset is used to discover X coordinate of a point
          const data = meta.data
          return data[pointIndex]._model.x
        },
        renderVerticalLine: function (chartInstance, pointIndex) {
          const lineLeftOffset = this.getLinePosition(chartInstance, pointIndex)
          const scale = chartInstance.scales['y-axis-0']
          const context = chartInstance.chart.ctx

          // render vertical line
          context.beginPath()
          context.lineWidth = 1
          context.strokeStyle = '#000000'
          context.moveTo(lineLeftOffset, scale.top)
          context.lineTo(lineLeftOffset, scale.bottom)
          context.stroke()

          // write label
          // // context.fillStyle = '#000000'
          // // context.textAlign = 'center'
          // // context.fillText('MES ACTUAL', lineLeftOffset, (scale.bottom - scale.top) / 2 + scale.top)
        },

        afterDatasetsDraw: function (chart, easing) {
          if (chart.config.lineAtIndex) {
            chart.config.lineAtIndex.forEach(pointIndex => this.renderVerticalLine(chart, pointIndex))
          }
        }
      }
      ChartJS.plugins.register(verticalLinePlugin)
    },
    updateChart () {
      this.chart.update()
    }
  },
  mounted () {
    this.initLineChart()
  }

}
</script>

<style lang='scss'>
.chart-container {
  margin-top: rem(30);
  margin-right: rem(30);
}
</style>



// WEBPACK FOOTER //
// src/components/predictiveModels/PollutionChart.vue